import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import store from "./redux/store/Store";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from '@mui/material/styles'
import "./Translation/i18n";
import mwtheme from "./mwtheme";

ReactDOM.render(
  <ThemeProvider theme={mwtheme}>
    <CssBaseline enableColorScheme />
    <Provider store={store}>
      <App />
    </Provider>
  </ThemeProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
